<template>
  <modal-wrap
    ref="PackingSlipEditModal"
    :name="modalName"
    :header-class="'packing-slip-edit-header'"
    :body-class="'packing-slip-edit-modal'"
    :hide-footer="true"
    size="lg"
  >
    <template #modal-title> Edit Packing Slip </template>
    <template #default>
      <div v-if="packingSlip && !packingSlip.id" class="d-flex justify-content-center p-4 packing-slip-preview-body">
        <b-spinner class="mt-1 ml-2" variant="success" small />
      </div>
      <div v-if="packingSlip && packingSlip.id">
        <PackingSlipItemsTable :packing-slip="packingSlip" index="edit" :is-edit="true" />
      </div>
      <div class="d-flex justify-content-between pt-5 pr-4 pl-4 mr-0">
        <b-button class="file-btn" variant="danger" @click="confirmDelete">
          <b-icon icon="trash" class="mr-2" variant="white" small />
          Delete
        </b-button>
      </div>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import type { PackingSlipState } from '@/types/Store'
import { BButton, BSpinner } from 'bootstrap-vue-next'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { PACKING_SLIP_EDIT, PACKING_SLIP_PREVIEW } from '@/const/ModalTypes'
import { openModal } from '@/services/Modal'
import { usePackingSlipStore } from '@/store/packingSlip'
import { useVueNextModalStore } from '@/store/vueNextModal'
import BIcon from '@/views/Components/Elements/Icons/BIcon.vue'
import ModalWrap from '@/views/Modals/ModalWrap.vue'
import PackingSlipItemsTable from '@/views/Components/PackingSlip/PackingSlipItemsTable.vue'

export default defineComponent({
  name: 'PackingSlipEditModal',
  components: {
    BSpinner,
    BButton,
    BIcon,
    PackingSlipItemsTable,
    ModalWrap,
  },
  setup() {
    const modalStore = useVueNextModalStore()
    const packingSlipStore = usePackingSlipStore()

    const modalName = PACKING_SLIP_EDIT
    const packingSlip: ComputedRef<PackingSlipState> = computed(() => packingSlipStore.packingSlip)

    const onDelete = () => {
      const id = packingSlip.value.id
      if (!id) {
        return
      }
      packingSlipStore.deletePackingSlip(String(id)).then(() => {
        packingSlipStore.getPackingSlips()
        modalStore.closeModal(PACKING_SLIP_EDIT)
        modalStore.closeModal(PACKING_SLIP_PREVIEW)
      })
    }

    const confirmDelete = () => {
      openModal('confirmWrap', {
        title: 'Delete Packing Slip',
        message: 'Are you sure you want to delete this packing slip? This action is irreversible.',
        onConfirm: onDelete,
      })
    }

    return {
      modalName,
      packingSlip,
      confirmDelete,
      openModal,
    }
  },
})
</script>
